import axios from 'axios';
import {
  fetchRefreshToken,
} from '../common/actions';
import { REFRESH_TOKEN_URL } from '../common/constant/app.properties';

const { ENABLE_AXIOS_OVERRIDE } = window.weeksWebCloudConfig;

let refreshingToken = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((promiseRequest) => {
    if (error) {
      promiseRequest.reject(error);
    } else {
      promiseRequest.resolve();
    }
  });
  failedQueue = [];
};
// console.log('ENABLE_AXIOS_OVERRIDE', axios.interceptors);
axios.interceptors.response.use(response => response, (error) => {
  if (ENABLE_AXIOS_OVERRIDE) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry
      && !originalRequest.url.includes(REFRESH_TOKEN_URL)
      && !originalRequest.url.includes('/validation')
    ) {
      if (refreshingToken) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => axios(originalRequest))
          .catch(err => Promise.reject(err));
      }
      originalRequest._retry = true;
      refreshingToken = true;
      return fetchRefreshToken()
        .then((res) => {
          refreshingToken = false;
          if (res.status === 200 && res && res.data && res.data.refresh_token_status === 'approved') {
            processQueue();
            return axios(originalRequest);
          }
          window.location.href = '/signout';
          processQueue(error);
          return Promise.reject(error);
        }, (res) => {
          if (res.status !== 200) {
            window.location.href = '/signout';
          }
        });
    }
  }
  return Promise.reject(error);
});

export default axios;
